import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import {catchError, Observable, of} from 'rxjs';
import {ConfigService} from '../services/config.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QuizGuard implements CanActivate {

  private readonly cooldownKey = 'quizCooldown';

  constructor(private router: Router, private configService: ConfigService) {}

  canActivate(): Observable<boolean> {
    return this.configService.getConfig().pipe(
      map(config => {
        if (!config.attemptsEnabled) return true; // Cooldown is OFF

        const last = localStorage.getItem(this.cooldownKey);
        if (!last) return true;

        let dbCooldown = config.attemptCooldown as unknown as number

        let cooldownPeriod = dbCooldown * 60 * 1000

        const elapsed = Date.now() - parseInt(last, 10);
        if (elapsed < (cooldownPeriod)) {
          this.router.navigate(['/quiz-cooldown']);
          return false;
        }

        return true;
      }),
      catchError(() => {
        // Fallback: allow or block based on your preference
        return of(true); // Fail open
      })
    );
  }
}
